import { AuthProvider } from '../../context/useAuthContext';
import { PermissionsProvider } from '../../context/usePermissions';
import { LayoutProvider } from '../../context/useLayoutContext';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const AppProvidersWrapper = ({
  children
}) => {
  return <>
    <HelmetProvider>
      <AuthProvider>
        <PermissionsProvider>
          <LayoutProvider>
            {/* <NotificationProvider> */}
            {children}
            {/* The app's only toast container: pages must not render their own (react-toastify 11
                keys containers by id, so a second one takes over and, on unmount, removes this one). */}
            <ToastContainer position="top-right" autoClose={3000} newestOnTop limit={3} theme="colored" />
            {/* </NotificationProvider> */}
          </LayoutProvider>
        </PermissionsProvider>
      </AuthProvider>
    </HelmetProvider>
  </>;
};
export default AppProvidersWrapper;